export default "__VITE_ASSET__D00iM_b4__"